import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Shows the basic REA data that the farmer can recognise before importing.
 */
@Component({
  selector: 'app-rea-import-basic-data',
  templateUrl: './rea-import-basic-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportBasicDataComponent {
  @Input({ required: true })
  public nif = '';

  @Input()
  public codigoRea = '';
}
